import { useNavigate } from "react-router-dom";
import { Vehicle } from "../../../types/Vehicle";
import { LoaderLinear } from "../../loader/loaderLinear.component";
import { AreaAdditions } from "./areaAdditions";
import { useGetNewAdditionsToVehicleQuery, useUpdateVehicleMutation } from "../../../state/api/vehicle.api";
import { useGetNewAdditionsToPartsQuery, useUpdatePartMutation } from "../../../state/api/parts.api";
import { setKeywordsForVehicle } from "../../vehicle/create/vehicleCreate.util";
import { useBrands } from "../../../hooks/useBrands";
import { useModels } from "../../../hooks/useModels";
import { Part } from "../../../types/Part";
import { setKeywordsOfParts } from "../../parts/create/partCreate.util";
import { Typography } from "@mui/material";
import { useCreateAreaMutation } from "../../../state/api/area.api";

export const AreaAdditionsContainer = () => {

    const { data: vehicles, isLoading: isLoadingVehicles, refetch: refetchVehicles } = useGetNewAdditionsToVehicleQuery('area');
    const { data: parts, isLoading: isLoadingParts, refetch: refetchParts } = useGetNewAdditionsToPartsQuery('area');

    const [createArea, { isLoading: loadingCreateModel }] = useCreateAreaMutation();

    const [updateVehicle, { isLoading: loadingUpdateVehicle }] = useUpdateVehicleMutation();
    const [updatePart, { isLoading: loadingUpdateParts }] = useUpdatePartMutation();

    const brands = useBrands();
    const models = useModels();

    const navigate = useNavigate();

    const handleViewVehicle = async (v: Vehicle | Part) => {
        navigate(`/vehicle/${v.id}`);
    }

    const handleViewPart = async (p: Vehicle | Part) => {
        navigate(`/sparepart/${p.id}`);
    }

    const handleAddArea = async (isVehicle: boolean, item: Vehicle | Part, areaId: number | undefined, areaString: string | undefined) => {

        let newAreaId;
        let areaResult: any;

        if (areaString) {
            areaResult = await createArea({
                country: item.country,
                province: item.province,
                district: item.district,
                label: areaString,
                UserId: item.UserId
            });

            if (areaResult.error) {
                return;
            } else {
                newAreaId = areaResult.data.id;
            }
        }

        const newExtraProps = { ...item.extraProps };
        delete newExtraProps.area;

        let response: any;
        if (isVehicle) {
            const newVehicle: Vehicle = {
                ...(item as Vehicle),
                area: newAreaId ?? areaId,
                extraProps: (newExtraProps)
            };
            const newVehicleWithKeywords = setKeywordsForVehicle(newVehicle, models, brands);
            response = await updateVehicle({
                veh: newVehicleWithKeywords
            });
            refetchVehicles();
        } else {
            const newPart: Part = {
                ...(item as Part),
                area: newAreaId ?? areaId,
                extraProps: (newExtraProps)
            };
            const newPartWithKeywords = setKeywordsOfParts(newPart, models, brands);
            response = await updatePart({
                part: newPartWithKeywords
            });
            refetchParts();
        }
    }

    if (isLoadingParts || isLoadingVehicles) {
        return <LoaderLinear />
    }

    return (
        <>
            <Typography variant="subtitle1">Vehicle Area Additions</Typography>
            <AreaAdditions
                isVehicle={true}
                loading={isLoadingVehicles}
                items={vehicles}
                addArea={handleAddArea}
                viewEntity={handleViewVehicle}
            />
            <Typography variant="subtitle1">Parts Area Additions</Typography>
            <AreaAdditions
                isVehicle={false}
                loading={isLoadingParts}
                items={parts}
                addArea={handleAddArea}
                viewEntity={handleViewPart}
            />
        </>
    );
}